<template>
    <div class="block">
      <Carousel trigger="click" ref="carousel" :autoplay="false" arrow="always" @change = "currentSlide" :class="{'last-slide':isLast}">
        <CarouselItem>
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="newuser"></div>
            </div>
            <div class="col-lg-5">
              <h4>Filter</h4>
              <p>Streamline things that you do</p>
              <p>Click on filters on the top left, within a few clicks sort the list of indents to quickly generate your invoice!</p>
            </div>
          </div>
        </CarouselItem>

        <CarouselItem>
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="newuser_timeline"></div>
            </div>
            <div class="col-lg-5">
              <h4>Timeline</h4>
              <p>Revisit everything you did</p>
              <p>Did you forget when THAT truck left THAT consignee? We've got you covered!</p>
              <p>Find every detail of every indent, chronologically.</p>
            </div>
          </div>
        </CarouselItem>

        <CarouselItem>
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="newuser_comments"></div>
            </div>
            <div class="col-lg-5">
              <h4>Comments & Attachments</h4>
              <p>Just in case</p>
              <p>Do you have comments to add to your invoice? Click on the right indent ID and start typing! Whats more? You can now attach documents to your comments</p>
            </div>
          </div>
        </CarouselItem>

        <CarouselItem class="last-slide">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="newuser_gst"></div>
            </div>
            <div class="col-lg-5">
              <h4>GST Compliance</h4>
              <p>Never fret about compliance again!</p>
              <p>Forget the double checking. The consolidate summary view will do it for you. You are one click away from invoice generation!</p>
            </div>
          </div>
        </CarouselItem>
      </Carousel>
    </div>
</template>
<script>
export default {
  data() {
    return {
      isLast: false,
    }
  },
  methods: {
    currentSlide(current,previous) {
      this.isLast = (current === 3);
      if(current === 0 && previous === 3) {
        this.$emit('closeDialog');
      }
    },
  }
}
</script>